function getLabel(groupName) {
  // We create a label element for the first item in the group
  const categoryLabel = document.createElement('span');

  // Apply some properties to the newly created label element
  categoryLabel.innerHTML = groupName;
  categoryLabel.className = 'awesomplete__category';

  return categoryLabel;
}

export default (el) => {
  const { ul } = el;

  let items = ul.querySelectorAll('li');
  items = Array.prototype.slice.call(items);

  let prevCat = '';

  items.forEach((item) => {
    const itemInst = item;
    const group = $(itemInst).data('group');

    if (group !== prevCat) {
      itemInst.appendChild(getLabel(group));
      itemInst.className = 'has-category';
    }

    prevCat = group;
  });
};
